import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Permissions } from 'services/permissions';
import LoadingCube from 'sub_components/Common/LoadingCube';
import LineGraph from 'sub_components/Common/LineGraph';
import { updateShares } from 'actions/storage';
import { ToggleButton } from 'styled_components/Common/ToggleButton';
import { DailySelector } from 'styled_components/SVG/DailySelector';
import { MonthlySelector } from 'styled_components/SVG/MonthlySelector';
import { HourlySelector } from 'styled_components/SVG/HourlySelector';

const theme1 = {
	account: '#416ba9',
	support: '#8060a9',
	storage: '#008388',
	billing: '#a8ad00',
	Cool_Gray_Med_1: '#a2a9ad',
	Cool_Gray_Light_3: '#edefef',
};

class ObjectGraphs extends Component {
	constructor(props) {
		super(props);

		this.state = {
			position: 'left',
			loading: true,
		};
	}

	getPackage = (data, type) => {
		let totalCommitment;
		const { packages } = data;
		if (packages.length) {
			totalCommitment = packages.filter(storagePackage => storagePackage.storageType === type);
			return totalCommitment[0];
		}
	};

	isEmpty = obj => {
		if (obj) {
			return Object.keys(obj).length === 0;
		}
	};

	getLength = series => {
		const filteredArray = series.filter(array => array?.data && array?.data.length !== 0);

		let dataLength = filteredArray?.length;

		if (dataLength === 1) {
			dataLength = 'one';
		} else if (dataLength === 2) {
			dataLength = 'two';
		} else if (dataLength === 3) {
			dataLength = 'three';
		} else if (dataLength === 4) {
			dataLength = 'four';
		}

		return dataLength;
	};

	render() {
		const {
			pages,
			loadMoreData,
			series,
			categories,
			breakpoint,
			unit,
			setResolution,
			commitment_amount,
			isOverCommitment,
		} = this.props;
		const { position } = this.state;

		const ViewObject = Permissions.checkComponentAccess(
			pages,
			'Storage Overview',
			'view-storage-object',
		);

		return (
			<div className='storage-overview-detail v3'>
				<div key='storage-graphs' className='storage-graphs'>
					{!series && <LoadingCube padding={true} />}
					{series && ViewObject && (
						<div className='object-graph'>
							<div className='graph-resolution-picker'>
								<ToggleButton
									module='storage'
									id='toggle-slider-5'
									theme={theme1}
									groupName='togglers-5'
								>
									<HourlySelector
										id='hourly-selector-1'
										module='storage'
										theme={theme1}
										className={'hourly'}
										value='HOUR'
										onClick={resolution => setResolution(resolution)}
									/>
									<DailySelector
										id='daily-selector-1'
										module='storage'
										theme={theme1}
										position={position}
										className={'daily'}
										value='DAY'
										onClick={resolution => setResolution(resolution)}
									/>
									<MonthlySelector
										id='monthly-selector-1'
										module='storage'
										theme={theme1}
										value='MONTH'
										className={'monthly'}
										onClick={resolution => setResolution(resolution)}
									/>
								</ToggleButton>
							</div>

							{series && series.length !== 0 && !this.isEmpty(series) && (
								<div className={`overview-graph ${this.getLength(series)}`}>
									<LineGraph
										id='storage-overview'
										series={series}
										categories={categories}
										size='large'
										title={``}
										breakpoint={breakpoint}
										commitment_amount={commitment_amount}
										loadMoreData={loadMoreData}
										isOverCommitment={isOverCommitment}
										unit={unit}
										resolution={'DAY'}
									/>
								</div>
							)}
						</div>
					)}
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		storage: state.storage,
	};
}

export default connect(mapStateToProps, { updateShares })(ObjectGraphs);
